import {formateData, headers} from "./index";
import {applicationName} from "../utils";

export const auditViewListInitDataSource = (start, size, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/auditView/list?"+formateData({
        start,size
    });
    fetch(url, {
        method: 'get',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include'
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:auditViewListInitDataSource",error);
        callBack({});
    })
};
export const auditViewAdd = (auditView, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/auditView/add";
    fetch(url, {
        method: 'post',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        body: formateData(auditView)
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:auditViewListInitDataSource",error);
        callBack({});
    })
};
export const auditViewUpdate = (auditView, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/auditView/edit";
    fetch(url, {
        method: 'post',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        body: formateData(auditView)
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:auditViewListInitDataSource",error);
        callBack({});
    })
};
export const auditViewDelete = (id, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/auditView/deleteById";
    fetch(url, {
        method: 'post',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        body: formateData(id)
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:auditViewListInitDataSource",error);
        callBack({});
    })
};

export const auditViewDeletes = (ids, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/auditView/deleteByIds";
    fetch(url, {
        method: 'post',
        cache: 'no-cache',
        headers: {
            ...headers,
            "Content-Type" : 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify(ids)
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:auditViewListInitDataSource",error);
        callBack({});
    })
};

//获取某个类型下的所有流程图
export const getActivitiFlow = (type, currentAccount, callBack) => {
    let url = "/cm-sites-activiti/activiti/getModelList";
    fetch(url, {
        method: 'get',
        cache: 'no-cache',
        headers: {
            ...headers,
            "Content-Type" : 'application/json'
        },
        credentials: 'include'
    }).then(response => response.json()).then(data => {
        callBack(data[type]);
    }).catch((error) => {
        console.error("getActivitiFlow:auditViewListInitDataSource",error);
        callBack({});
    })
};

export const getSameNameAllNodes = (id, callBack)=>{
    let url = "/cm-sites-" + applicationName() + "/auditView/getSameNameAllNodes?id="+id;
    fetch(url, {
        method: 'post',
        cache: 'no-cache',
        headers: {
            ...headers,
            "Content-Type" : 'application/json',
        },
        credentials: 'include',
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("getSameNameAllNodes:auditViewListInitDataSource",error);
        callBack({});
    })
};